/**
 * Converts a JSON Schema inputSchema (used by tool-runtime MANIFESTs and schema files)
 * into the GUI's ParameterSchema[] format (used by SelfContainedCommand.schema.parameters).
 *
 * This bridges the two formats so GUI commands can derive their schema directly from
 * the canonical schema files colocated with each app, eliminating description duplication.
 */
export function schemaToParameters(inputSchema: Record<string, any>) {
  const properties = inputSchema?.properties ?? {};
  const required: string[] = inputSchema?.required ?? [];
  return Object.entries(properties).map(([name, def]: [string, any]) => ({
    name,
    type: def.type as any,
    description: def.description ?? '',
    required: required.includes(name),
    ...(def.default !== undefined ? { defaultValue: def.default } : {}),
    ...(def.enum ? { enum: def.enum } : {}),
    ...(def.items ? { items: def.items } : {}),
  }));
}
